/**
 * HRNext Performance WebApi
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: v1
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import {
  GetThreeSixtyDashboardRequest,
  ScoreToPerformanceRequest,
  ThreeSixtyEvaluationTransferDto,
  ThreeSixtyManagerDashboardQuery,
  ThreeSixtyPeriodDto,
  ThreeSixtyPeriodEditViewModel,
  ThreeSixtyPeriodTranslatedDto,
} from './models';
import { LinqService, QueryOptions } from 'linquest';

import { IAjaxProvider } from 'jinqu';

/**
 * ThreeSixtyPeriodApi - API class
 */
export class ThreeSixtyPeriodApi extends LinqService {

  /**
   * Creates a new ThreeSixtyPeriodApi class.
   *
   * @param ajaxProvider The Linquest Ajax Provider to inject. When not specified, default Fetch provider will be used.
   */
  constructor(ajaxProvider?: IAjaxProvider) {
    super("/performance-api", ajaxProvider);
  }

  /**
   * @param dto 
   */
  addOrUpdateAsync(dto?: ThreeSixtyPeriodDto, options?: QueryOptions) {
    // create query
    const url = `/ThreeSixtyPeriod/AddOrUpdateAsync`;
    let query = this.createQuery<any>(url);

    // initialize options
    options = options || {};
    options.method = options.method || 'POST';
    options.params = options.params || [];
    options.headers = options.headers || {};

    // set body parameter
    options.data = dto;
    query = query.withOptions(options);

    return query.firstAsync();
  }

  /**
   * @param id 
   */
  deleteAsync(id?: string, options?: QueryOptions) {
    // create query
    const url = `/ThreeSixtyPeriod/DeleteAsync`;
    let query = this.createQuery<any>(url);

    // initialize options
    options = options || {};
    options.method = options.method || 'GET';
    options.params = options.params || [];
    options.headers = options.headers || {};

    // set query parameters
    options.params.push({ key: 'Id', value: id && id.toString() });
    query = query.withOptions(options);

    return query.firstAsync();
  }

  /**
   * @param id 
   */
  getAsync(id?: string, options?: QueryOptions) {
    // create query
    const url = `/ThreeSixtyPeriod/GetAsync`;
    let query = this.createQuery<ThreeSixtyPeriodDto>(url);

    // initialize options
    options = options || {};
    options.method = options.method || 'GET';
    options.params = options.params || [];
    options.headers = options.headers || {};

    // set query parameters
    options.params.push({ key: 'Id', value: id && id.toString() });
    query = query.withOptions(options);

    return query.firstAsync();
  }

  /**
   * @param request 
   */
  getThreeSixtyDashboard(request?: GetThreeSixtyDashboardRequest, options?: QueryOptions) {
    // create query
    const url = `/ThreeSixtyPeriod/GetThreeSixtyDashboard`;
    let query = this.createQuery<ThreeSixtyManagerDashboardQuery>(url);

    // initialize options
    options = options || {};
    options.method = options.method || 'POST';
    options.params = options.params || [];
    options.headers = options.headers || {};

    // set body parameter
    options.data = request;
    query = query.withOptions(options);

    return query;
  }

  /**
   * @param threeSixtyPeriodId 
   */
  getThreeSixtyPeriodEditViewModel(threeSixtyPeriodId?: string, options?: QueryOptions) {
    // create query
    const url = `/ThreeSixtyPeriod/GetThreeSixtyPeriodEditViewModel`;
    let query = this.createQuery<ThreeSixtyPeriodEditViewModel>(url);

    // initialize options
    options = options || {};
    options.method = options.method || 'POST';
    options.params = options.params || [];
    options.headers = options.headers || {};

    // set body parameter
    options.data = threeSixtyPeriodId;
    query = query.withOptions(options);

    return query.firstAsync();
  }

  /**
   * @param id 
   */
  getTranslatedAsync(id?: string, options?: QueryOptions) {
    // create query
    const url = `/ThreeSixtyPeriod/GetTranslatedAsync`;
    let query = this.createQuery<ThreeSixtyPeriodTranslatedDto>(url);

    // initialize options
    options = options || {};
    options.method = options.method || 'GET';
    options.params = options.params || [];
    options.headers = options.headers || {};

    // set query parameters
    options.params.push({ key: 'Id', value: id && id.toString() });
    query = query.withOptions(options);

    return query.firstAsync();
  }

  /**
   * @param threeSixtyPeriodId 
   */
  hasAnyChild(threeSixtyPeriodId?: string, options?: QueryOptions) {
    // create query
    const url = `/ThreeSixtyPeriod/HasAnyChild`;
    let query = this.createQuery<boolean>(url);

    // initialize options
    options = options || {};
    options.method = options.method || 'GET';
    options.params = options.params || [];
    options.headers = options.headers || {};

    // set query parameters
    options.params.push({ key: 'threeSixtyPeriodId', value: threeSixtyPeriodId && threeSixtyPeriodId.toString() });
    query = query.withOptions(options);

    return query.firstAsync();
  }

  /**
   */
  list(options?: QueryOptions) {
    // create query
    const url = `/ThreeSixtyPeriod/List`;
    let query = this.createQuery<ThreeSixtyPeriodDto>(url);

    // initialize options
    options = options || {};
    options.method = options.method || 'GET';
    options.params = options.params || [];
    options.headers = options.headers || {};

    query = query.withOptions(options);

    return query;
  }

  /**
   */
  listTranslated(options?: QueryOptions) {
    // create query
    const url = `/ThreeSixtyPeriod/ListTranslated`;
    let query = this.createQuery<ThreeSixtyPeriodTranslatedDto>(url);

    // initialize options
    options = options || {};
    options.method = options.method || 'GET';
    options.params = options.params || [];
    options.headers = options.headers || {};

    query = query.withOptions(options);

    return query;
  }

  /**
   * @param dto 
   */
  saveAsync(dto?: ThreeSixtyPeriodDto, options?: QueryOptions) {
    // create query
    const url = `/ThreeSixtyPeriod/SaveAsync`;
    let query = this.createQuery<any>(url);

    // initialize options
    options = options || {};
    options.method = options.method || 'POST';
    options.params = options.params || [];
    options.headers = options.headers || {};

    // set body parameter
    options.data = dto;
    query = query.withOptions(options);

    return query.firstAsync();
  }

  /**
   * @param request 
   */
  transferThreeSixtyScoreToPerformance(request?: ScoreToPerformanceRequest, options?: QueryOptions) {
    // create query
    const url = `/ThreeSixtyPeriod/TransferThreeSixtyScoreToPerformance`;
    let query = this.createQuery<ThreeSixtyEvaluationTransferDto>(url);

    // initialize options
    options = options || {};
    options.method = options.method || 'POST';
    options.params = options.params || [];
    options.headers = options.headers || {};

    // set body parameter
    options.data = request;
    query = query.withOptions(options);

    return query.firstAsync();
  }
}
